import { AnimatePresence, motion } from "framer-motion"
import { useEffect, useState } from "react"

function Tabs({
  className,
  data,
  navClassName,
  callback,
  activeTabProps,
  setActiveTabProps,
  children,
}) {
  const [activeTab, setActiveTab] = useState(activeTabProps || 0)
  useEffect(() => {
    if (!activeTabProps) {
      setActiveTab(data[0])
    }
  }, [data, activeTabProps])
  useEffect(() => {
    if (activeTabProps) {
      setActiveTab(activeTabProps)
    }
  }, [activeTabProps])
  return (
    <div className={`tabs ${className}`}>
      <div className={`tabs-navigation ${navClassName}`}>
        <ul>
          {data?.map((item, i) => (
            <li
              className={`tabs-navigation-item ${
                item.key === activeTab?.key ? "active" : ""
              }`}
              key={item.key}
              role="presentation"
              onClick={() => {
                if (activeTabProps && setActiveTabProps) setActiveTabProps(item)
                else {
                  setActiveTab(item)
                }
                if (callback) callback(item)
              }}
            >
              {item.title}
              {item.key === activeTab?.key ? (
                <div className="underline" />
              ) : null}
            </li>
          ))}
        </ul>
      </div>
      <div className="tabs-content">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab?.key || "tabs-content-item"}
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -10, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {activeTab?.content ? activeTab?.content : children || null}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  )
}

export default Tabs
